import * as path from "path";
import axios from "axios";

/**
 * Don know why cannot import store in this file
 * problem may be in execute file order!!
 * <<WILL COME BACK TO FIND IT LATER>>
 */
export const basename = document.querySelector("meta[name='basename']").getAttribute("content") ?? "/";
export const csrf_token = document.querySelector("meta[name='csrf-token']").getAttribute("content") ?? "";
export const apiBasename = path.join(basename, "/");

const httpClient = axios.create({
    baseURL: apiBasename,
    withCredentials: true,
    headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        "X-CSRF-TOKEN": csrf_token,
    },
});

export default httpClient;
